import React from 'react'
import Icon from '@/components/icons/x-mark';
import Button from '@/components/atoms/project-builder/button';
import Popup from '@/components/atoms/project-builder/popup';

const SaveConfirmationPopup: React.FC<any> = ({isOpen,handleDiscard, handleSaveNContinue, handleClose,disabledSaveNContinue }) => {
    if (!isOpen) return null;
    return (
        <Popup isOpen={isOpen} bodyClassNames="sm:mx-unset max-w-[375px]">
            <div className="break-words p-[25px]">
                <div className="flex">
                    <p className="mt-[27px] whitespace-normal text-gray-700">
                        Changes are not saved. Please save or discard.
                    </p>
                    <div className="cursor-p" onClick={handleClose}>
                        <Icon />
                    </div>
                </div>
                <div className="mt-[51px] flex justify-between gap-[20px]">
                    <Button
                        variant={'secondary'}
                        className="!px-[24px] cursor-pointer hover:shadow-md hover:shadow-gray-300 !hover:bg-white !py-[8px] !text-[16px] font-medium disabled:border-gray-200"
                        type="button"
                        onClick={(e) => handleSaveNContinue(e)}
                        disabled={disabledSaveNContinue}
                    >
                        Save and continue
                    </Button>
                    <Button
                        variant={'secondary'}
                        className="!px-[24px] cursor-pointer hover:shadow-md hover:shadow-gray-300 !hover:bg-white !py-[8px] !text-[16px]  font-medium"
                        type="button"
                        onClick={handleDiscard}
                    >
                        Discard changes
                    </Button>
                </div>
            </div>
        </Popup>
    );
};

export default SaveConfirmationPopup;
